"use client";

import { ArrowUpRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Separator } from "@/components/ui/separator";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { WvcLogo } from "@/integrations/wordpress/WvcLogo";
function FooterNavConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <ul className="flex flex-col gap-3">
        {[0, 1, 2, 3, 4].map(i => <li key={i} data-index={i} className="h-4 w-32 bg-muted/20 animate-pulse rounded-md" />)}
      </ul>;
  }
  return <ul className="flex flex-col gap-3">
      {menuItems.map((item, i) => <li data-index={i} key={item.id}>
          <Link to={item.href || "#"} className="group inline-flex items-center gap-1.5 text-sm text-foreground transition-colors hover:text-[color:var(--chart-2)]">
            <span className="relative font-default">
              {item.label}
              <span className="absolute -bottom-0.5 left-0 h-px w-0 bg-[color:var(--chart-2)] transition-all duration-300 group-hover:w-full" />
            </span>
            <ArrowUpRight className="size-3 -translate-y-0.5 translate-x-0 opacity-0 transition-all duration-300 group-hover:translate-x-0.5 group-hover:opacity-100" />
          </Link>
        </li>)}
    </ul>;
}
const connectLinks = [{
  label: "Executive Training",
  to: "#"
}, {
  label: "Corporate Capacity",
  to: "#"
}, {
  label: "Enrolment Packages",
  to: "#"
}, {
  label: "AI Productivity",
  to: "#"
}];
const socialLinks = [{
  label: "LinkedIn",
  to: "#"
}, {
  label: "Instagram",
  to: "https://www.instagram.com/africabusiness_school/"
}, {
  label: "Facebook",
  to: "https://www.facebook.com/AfricabusinessandInnovationSchool"
}];
export default function InstitutionalFooter() {
  return <section data-section-id="605" id="institutional-footer" className="dark bg-background text-foreground pt-24 pb-12 px-6 md:px-10 lg:px-16">
      <div className="mx-auto max-w-7xl">
        <Separator className="bg-border/20" />

        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 md:gap-8 pt-16 md:pt-20">
          
          <div className="md:col-span-12 lg:col-span-4 flex flex-col gap-6">
            <Link to="/HomePage" className="inline-block">
              <WvcLogo className="!w-[52px] !h-[62px] [&_svg]:!w-[52px] [&_svg]:!h-[62px]" />
            </Link>
            <p className="font-default text-sm leading-relaxed text-muted-foreground max-w-xs">
              Africa Business and Innovation School is a forward-thinking institution dedicated to equipping professionals with the skills needed to thrive in today’s global economy.
            </p>
            <address className="not-italic font-mono text-[11px] uppercase tracking-widest text-muted-foreground leading-relaxed">Movenpick Ambassador hotel,presidential floor<br />Greater Accra,Ghana<br /><font color="oklab(0.985953 0.000229299 0.00195301 / 0.7)">africabusinessschool12@gmail.com</font></address>
          </div>

          
          <div className="md:col-span-4 lg:col-span-3 lg:col-start-6 flex flex-col gap-6">
            <div className="flex items-center gap-3">
              <span className="font-mono text-[11px] uppercase tracking-widest text-muted-foreground">
                01 — Academy
              </span>
            </div>
            <MenuProvider menu_id="17">
              <FooterNavConsumer />
            </MenuProvider>
          </div>

          
          <div className="md:col-span-4 lg:col-span-2 flex flex-col gap-6">
            <div className="flex items-center gap-3">
              <span className="font-mono text-[11px] uppercase tracking-widest text-muted-foreground">
                02 — Programmes
              </span>
            </div>
            <ul className="flex flex-col gap-3">
              {connectLinks.map((item, i) => <li data-index={i} key={item.label}>
                  <Link to={item.to} className="group inline-flex items-center gap-1.5 text-sm text-foreground transition-colors hover:text-[color:var(--chart-2)]">
                    <span className="relative font-default">
                      {item.label}
                      <span className="absolute -bottom-0.5 left-0 h-px w-0 bg-[color:var(--chart-2)] transition-all duration-300 group-hover:w-full" />
                    </span>
                  </Link>
                </li>)}
            </ul>
          </div>

          
          <div className="md:col-span-4 lg:col-span-2 flex flex-col gap-6">
            <div className="flex items-center gap-3">
              <span className="font-mono text-[11px] uppercase tracking-widest text-muted-foreground">
                03 — Network
              </span>
            </div>
            <ul className="flex flex-col gap-3">
              {socialLinks.map((item, i) => <li data-index={i} key={item.label}>
                  <Link to={item.to} newTab className="group inline-flex items-center gap-1.5 text-sm text-foreground transition-colors hover:text-[color:var(--chart-2)]">
                    <span className="relative font-default">
                      {item.label}
                      <span className="absolute -bottom-0.5 left-0 h-px w-0 bg-[color:var(--chart-2)] transition-all duration-300 group-hover:w-full" />
                    </span>
                    <ArrowUpRight className="size-3 -translate-y-0.5 translate-x-0 opacity-60 transition-all duration-300 group-hover:translate-x-0.5 group-hover:opacity-100" />
                  </Link>
                </li>)}
            </ul>
          </div>
        </div>

        <div className="h-20" />

        <Separator className="bg-border/20" />

        
        <div className="pt-8 flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
          <p className="font-mono text-[11px] uppercase tracking-widest text-muted-foreground">
            © 2025 Africa Business and Innovation School
          </p>
          <p className="font-mono text-[11px] uppercase tracking-widest text-muted-foreground">
            Excellence in Leadership
          </p>
        </div>
      </div>
    </section>;
}